import * as React from "react";
import { IconButton, Icon } from "@chakra-ui/react";
import { IoCloseOutline, IoChevronBack } from "react-icons/io5";
import { Link } from "react-router-dom";

interface BackButtonProps {
  chevron?: boolean;
  backURL?: string | number;
}

const BackButton: React.FC<BackButtonProps> = ({ backURL, chevron = true }) => (
  <IconButton
    aria-label="Go Back"
    size="sm"
    variant="unstyled"
    display="inline-flex"
    alignItems="center"
    as={Link}
    to={(backURL || -1) as any}
  >
    <Icon
      as={chevron ? IoChevronBack : IoCloseOutline}
      boxSize="26px"
      color="gray.700"
    />
  </IconButton>
);

export default BackButton;
